import { render } from "./GalleryComp.vue?vue&type=template&id=a7a82c86"
import script from "./GalleryComp.vue?vue&type=script&lang=js"
export * from "./GalleryComp.vue?vue&type=script&lang=js"

import "./GalleryComp.vue?vue&type=style&index=0&id=a7a82c86&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__